import React from 'react';
import Navigation from './Navigation';
import { useState, useEffect } from 'react';
import MenuService from './MenuService';
import { Table } from 'react-bootstrap';

const MyOrders = () => {
    const [myOrders, setMyOrders] = useState([]);

    useEffect(() => {
        const menuService = new MenuService();
        menuService.getMyOrders().then(orders => {
            setMyOrders(orders);
        });
    }, []);

    return (
        <div>
            <Navigation title="Mijn bestellingen" activeItem="mijnBestellingen" />
            {myOrders.length === 0 && <p>Je hebt nog geen bestellingen geplaatst, ga via het menu naar de bestelpagina.</p>}
            <ul>
                {myOrders.map(order => {
                    const orderDate = new Date(order.orderDate);
                    const options = { weekday: 'long' };
                    const dayOfWeek = orderDate.toLocaleDateString('nl-NL', options);
                    const hours = orderDate.getHours().toString().padStart(2, '0');
                    const minutes = orderDate.getMinutes().toString().padStart(2, '0');
                    return (
                        <li key={order.id}>
                            Bestelnr {order.id} - {order.orderLines.length} items - {order.extraGlasses} glazen - {dayOfWeek} {hours}u{minutes}
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th scope="col">Product</th>
                                        <th scope="col" style={{ width: '20%' }}>#</th>
                                        <th scope="col">Prijs</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order.orderLines.map((line, index) => (
                                        <tr key={index}>
                                            <td>{line.product.productName}</td>
                                            <td>
                                                {line.quantity}
                                            </td>
                                            <td>{parseFloat(line.product.price * line.quantity).toFixed(2)}€
                                                </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="2">Totaal</td>
                                        <td>{parseFloat(order.orderLines.reduce((total, line, index) => total + line.product.price * line.quantity, 0))}€
                                            </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};



export default MyOrders;